export default "__VITE_ASSET__l2J$MmSk__"